<template>
  <div>
    <ontick-aero :active="active">
      <div v-show="active" class="ml-10 w-screen max-w-md">
        <div
          class="glass-carbon flex h-full flex-col overflow-y-scroll shadow-xl"
        >
          <div class="glass-carbon sticky top-0 px-6 py-3 pr-14 shadow-lg">
            <div class="flex items-center justify-start">
              <button
                @click="$emit('close')"
                class="focus:outline-none py-1 text-gray-400 hover:text-gray-400"
              >
                <span v-html="$icons.arrow_left" />
              </button>
              <p
                class="mx-3 text-left text-ontick-carbon-900 dark:text-gray-300"
              >
                Minhas contas
              </p>
            </div>
          </div>
          <div class="flex h-full items-center">
            <div class="grid grid-cols-2 gap-3 px-6">
              <div
                @click.stop="optionSelected(item)"
                :class="
                  accountTypes.selectedAccount.broker_name == item.broker_name
                    ? 'bg-gray-50 dark:bg-ontick-graphite-500'
                    : 'bg-none'
                "
                class="rounded-md px-3 py-3 transition-all duration-150"
                v-for="(item, key) in accountTypes.accounts"
                :key="key"
              >
                <div class="flex justify-center">
                  <div
                    class="h-12 w-12 text-center"
                    v-html="itemLogo(item.broker_name)"
                  ></div>
                </div>
                <div class="flex items-center justify-between space-x-2">
                  <p
                    class="py-2 font-medium text-ontick-carbon-900 dark:text-gray-300"
                  >
                    {{ item.broker_name }}
                  </p>
                  <p class="text-xs text-gray-400">
                    (#{{ item.account_number }})
                  </p>
                </div>
                <div class="flex items-center justify-between">
                  <div class="flex w-8 items-center">
                    <div
                      v-show="item.num_running > 0"
                      class="absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full bg-ontick-green-500 opacity-75"
                    ></div>
                    <div
                      class="h-3 w-3 rounded-full"
                      :class="
                        item.num_running == 0
                          ? 'bg-gray-400'
                          : 'bg-ontick-green-500'
                      "
                    ></div>

                    <span
                      class="mx-1 text-sm text-ontick-carbon-900 dark:text-gray-300"
                      >{{ item.num_running }}</span
                    >
                  </div>
                  <div
                    :class="
                      item.account_type == 'DEMO'
                        ? 'bg-gray-500 text-gray-200'
                        : 'bg-ontick-blue-900 text-ontick-blue-500'
                    "
                    class="inline-flex items-center rounded px-2 py-1 text-xs font-semibold"
                  >
                    {{ item.account_type == "DEMO" ? "DEMO" : "PROD" }}
                  </div>
                </div>
              </div>

              <div
                @click="modal_active = true"
                class="relative my-3 flex cursor-pointer items-center justify-center rounded-lg px-3 py-3 text-center md:px-6 md:py-6"
              >
                <div>
                  <div class="flex justify-center">
                    <svg
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M24.4502 0.0996094C18.085 0.0996094 11.9805 2.62817 7.47963 7.12904C2.97876 11.6299 0.450195 17.7344 0.450195 24.0996C0.450195 30.4648 2.97876 36.5693 7.47963 41.0702C11.9805 45.571 18.085 48.0996 24.4502 48.0996C30.8154 48.0996 36.9199 45.571 41.4208 41.0702C45.9216 36.5693 48.4502 30.4648 48.4502 24.0996C48.4502 17.7344 45.9216 11.6299 41.4208 7.12904C36.9199 2.62817 30.8154 0.0996094 24.4502 0.0996094ZM21.4502 33.0996C21.4502 33.8953 21.7663 34.6583 22.3289 35.2209C22.8915 35.7835 23.6545 36.0996 24.4502 36.0996C25.2458 36.0996 26.0089 35.7835 26.5715 35.2209C27.1341 34.6583 27.4502 33.8953 27.4502 33.0996V27.0996H33.4502C34.2458 27.0996 35.0089 26.7835 35.5715 26.2209C36.1341 25.6583 36.4502 24.8953 36.4502 24.0996C36.4502 23.304 36.1341 22.5409 35.5715 21.9783C35.0089 21.4157 34.2458 21.0996 33.4502 21.0996H27.4502V15.0996C27.4502 14.304 27.1341 13.5409 26.5715 12.9783C26.0089 12.4157 25.2458 12.0996 24.4502 12.0996C23.6545 12.0996 22.8915 12.4157 22.3289 12.9783C21.7663 13.5409 21.4502 14.304 21.4502 15.0996V21.0996H15.4502C14.6545 21.0996 13.8915 21.4157 13.3289 21.9783C12.7663 22.5409 12.4502 23.304 12.4502 24.0996C12.4502 24.8953 12.7663 25.6583 13.3289 26.2209C13.8915 26.7835 14.6545 27.0996 15.4502 27.0996H21.4502V33.0996Z"
                        fill="#2D3748"
                      />
                    </svg>
                  </div>
                  <span class="trucante">
                    <p
                      class="mt-3 text-xs text-ontick-carbon-900 dark:text-gray-300 xl:text-sm"
                    >
                      Adicionar nova conta
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div></ontick-aero
    >
    <modal-account
      @close="modal_active = false"
      v-if="modal_active"
      :active="modal_active"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import NotificationAccountComponent from "../../../modules/notification/components/notification-account.component.vue";
import ModalAccount from "../modal-account/modal.component";

export default {
  props: { active: { type: Boolean } },

  data() {
    return {
      toggleSelect: false,
      optionDefault: null,
      modal_active: false,
    };
  },

  components: { ModalAccount },

  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
    }),
  },

  methods: {
    ...mapActions({
      updateAccount: "accountTypes/updateAccount",
    }),

    optionSelected(item) {
      var ehEditInvestment = false;
      if (this.$route.path.split("/").length == 4) {
        var path = this.$route.path.split("/");
        if (path[1] == "investments" && path[3] == "edit") {
          ehEditInvestment = true;
        }
      }
      if (!ehEditInvestment) {
        // Caso não esteja em editar parâmetros, deve atualizar a conta normalmente.
        this.toggleSelect = false;
        let params = { account: item, router: this.$route.path };

        if (
          this.accountTypes.selectedAccount.account_number !=
          item.account_number
        ) {
          this.updateAccount(params);

          const content = {
            component: NotificationAccountComponent,
            props: {
              id:
                this.accountTypes.selectedAccount.broker_name +
                " #" +
                this.accountTypes.selectedAccount.account_number,
              account: this.accountTypes.selectedAccount.account_type,
              title: `Você está usando uma conta ${
                this.accountTypes.selectedAccount.account_type == "DEMO"
                  ? "DEMO"
                  : "PRODUÇÃO"
              }.`,
              message: `Sua troca de contas foi efetuada com sucesso. ${
                this.accountTypes.selectedAccount.account_type == "DEMO"
                  ? " "
                  : "Bons investimentos!"
              }`,
              icons: this.itemLogo(
                this.accountTypes.selectedAccount.broker_name
              ),
            },
          };
          this.$toast(content, {
            bodyClassName: "notification",
            toastClassName: "notification",
            position: "top-right",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            closeButtonClassName: "close_button",
            hideProgressBar: true,
            // closeButton: "button",
            icon: false,
            rtl: false,
          });

          this.$emit("close");
        } else {
          this.toggleSelect = false;
          this.tempParams = { account: item, router: this.$route.path };
          // Não é pra  alterar a conta, apenas mandar o evento.
          EventBus.$emit("CHANGE_ACCOUNT");
        }
      }
    },

    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },
  },
};
</script>

<style></style>
